var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-item-group",
                {
                  attrs: { mandatory: "" },
                  model: {
                    value: _vm.type,
                    callback: function($$v) {
                      _vm.type = $$v
                    },
                    expression: "type"
                  }
                },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-item", {
                            attrs: { value: "cash" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function({ toggle, active }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: active
                                            ? "green"
                                            : "blue-grey darken-3",
                                          dense: "",
                                          block: "",
                                          tile: "",
                                          dark: "",
                                          elevation: "0",
                                          text: !active
                                        },
                                        on: { click: toggle }
                                      },
                                      [_vm._v("CASH")]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-item", {
                            attrs: { value: "cheque" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function({ toggle, active }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: active
                                            ? "blue"
                                            : "blue-grey darken-3",
                                          dense: "",
                                          dark: "",
                                          tile: "",
                                          elevation: "0",
                                          block: "",
                                          text: !active
                                        },
                                        on: { click: toggle }
                                      },
                                      [_vm._v("CHEQUE")]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider")
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-switch", {
                attrs: { inset: "", label: "Returned", "hide-details": "" },
                model: {
                  value: _vm.returned,
                  callback: function($$v) {
                    _vm.returned = $$v
                  },
                  expression: "returned"
                }
              })
            ],
            1
          ),
          _vm.type === "cheque"
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Cheque Number",
                      dense: "",
                      "hide-details": "auto",
                      "error-messages":
                        _vm.voucherTransactionPostErrors.cheque_number
                    },
                    model: {
                      value: _vm.chequeNumber,
                      callback: function($$v) {
                        _vm.chequeNumber = $$v
                      },
                      expression: "chequeNumber"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Amount",
                  type: "number",
                  dense: "",
                  "hide-details": "auto",
                  "error-messages": _vm.voucherTransactionPostErrors.amount
                },
                model: {
                  value: _vm.amount,
                  callback: function($$v) {
                    _vm.amount = _vm._n($$v)
                  },
                  expression: "amount"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Date",
                  type: "date",
                  dense: "",
                  "hide-details": "auto",
                  "error-messages": _vm.voucherTransactionPostErrors.date
                },
                model: {
                  value: _vm.date,
                  callback: function($$v) {
                    _vm.date = $$v
                  },
                  expression: "date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              !_vm.editMode
                ? _c("v-text-field", {
                    attrs: {
                      label: "Status",
                      disabled: "",
                      dense: "",
                      "hide-details": "auto",
                      value: this.statusDescription
                    }
                  })
                : _c("v-autocomplete", {
                    attrs: {
                      label: "Status",
                      dense: "",
                      "error-messages":
                        _vm.voucherTransactionPostErrors
                          .voucher_cheque_status_id,
                      items: _vm.voucherChequeStatusIndexList,
                      "item-value": "id",
                      "item-text": "description",
                      "hide-details": "auto"
                    },
                    model: {
                      value: _vm.voucherChequeStatusId,
                      callback: function($$v) {
                        _vm.voucherChequeStatusId = $$v
                      },
                      expression: "voucherChequeStatusId"
                    }
                  })
            ],
            1
          ),
          !_vm.editMode
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        dense: "",
                        block: "",
                        color: "primary",
                        loading: _vm.voucherTransactionPosting
                      },
                      on: {
                        click: function($event) {
                          return _vm.store()
                        }
                      }
                    },
                    [_c("span", [_vm._v("Save")])]
                  )
                ],
                1
              )
            : _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "yellow darken-2",
                                dark: "",
                                dense: "",
                                small: "",
                                block: "",
                                loading: _vm.voucherTransactionPosting
                              },
                              on: {
                                click: function($event) {
                                  return _vm.update()
                                }
                              }
                            },
                            [_c("span", [_vm._v("Update")])]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "red",
                                dark: "",
                                dense: "",
                                small: "",
                                block: ""
                              },
                              on: {
                                click: function($event) {
                                  _vm.editMode = false
                                }
                              }
                            },
                            [_c("span", [_vm._v("Cancel")])]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }